(ns ycweb.app.blitz.transfers.transfers
  (:require
   [rum.core :as rum]
   [ycweb.components.forms :as forms]
   [ycweb.util.core :as u]
   [ycweb.components.grid :as grid]
   [ycweb.components.wrapper :as w]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.common :as cmn]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.flow :as flow]
   [inflections.core :as inflections]))

(def steps
  (forms/setup-steps
    [{:key :select-option :title "Select Option"}
     {:key :order-list :title "Select Transfer Order"}
     {:key :printer-scan :title "Scan Printer"}
     {:key :item-list :title "Scan Products"}
     {:key :ship :title "Ship Order"}
     {:key :finished :title "Confirm"}]))

(defmethod grid/action :transfers/ship-reprint [app-atom]
  (let [{:keys [printer session-id]} (get @app-atom :transfers)]
    (comms/send :transfers/ship-reprint
      {:session-id session-id
       :printer-barcode printer})))

(defmethod flow/barcode-dispatch-screen :transfers/finished [_ app-atom _]
  (grid/dispatch-action app-atom :transfers/ship-reprint {}))

(rum/defc finished < rum/reactive [app-atom]
  (w/wrapper app-atom "Transfer Stock" {:steps steps :step :finished}
    [[:div
      {:class (u/bem :section [:medium])}
      [:h2.u-text-center
       {:class (u/bem :heading [:large])}
       [:b "Thank you!"]]
      [:i.u-block-center
       {:class (u/bem :icon [:3-3 :emoticon-happy :enormous :block])}]
      [:div.u-margin-top-24
       [:p.u-text-center
        {:class (u/bem :paragraph [:flush :large])}
        [:b "Put the stickers on the boxes"]]]]]

    [[:aside.page-body__footer
      [:p.paragraph.paragraph--flush.u-text-center
       "Scan a printer to reprint"]]]
    (grid/pos-call-to-action
      {:single-fn #(grid/dispatch-action app-atom :transfers/order-list {})})))

(defmethod comms/receive :transfers/ship [app-atom]
  (toaster/close-toast app-atom)
  (t/transition-next app-atom :transfers/finished))

(defmethod grid/action :transfers/ship [app-atom]
  (toaster/open-toast app-atom :processing "Shipping" {})
  (let [{:keys [printer session-id sync-uuid]} (get @app-atom :transfers)]
    (comms/send :transfers/ship
      {:sync-uuid sync-uuid
       :session-id session-id
       :printer-barcode printer})))

(defmethod flow/render-screen :transfers/finished [app-atom _]
  (finished app-atom))

(defmethod grid/action :transfers/menu-item-barcode [app-atom _ _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :transfers/item-scan
     :input-key :scan
     :input-type :barcode}))

(defmethod grid/action :transfers/menu-printer-barcode [app-atom _ _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :transfers/printer-scan
     :input-key :scan
     :input-type :barcode}))

(defmethod flow/barcode-dispatch-modal :transfers/modal-item-unscan [_ app-atom scan]
  (grid/dispatch-modal-action app-atom :transfers/item-unscan {:scan scan}))

(defmethod grid/action :transfers/item-unscan [app-atom {:keys [scan manual-barcode]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [session-id packbox sync-uuid]} (get-in @app-atom [:transfers])]
    (comms/send :transfers/item-scan
      {:scan (or scan manual-barcode)
       :qty -1
       :packbox-id (:id packbox)
       :session-id session-id
       :sync-uuid sync-uuid})))

(defmethod grid/modal-config :transfers/modal-item-unscan [_ _ _]
  {:body grid/single-input-modal-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

(defmethod grid/action :transfers/menu-unscan [app-atom _ _]
  (grid/open-modal app-atom :transfers/modal-item-unscan
    {:config
     {:title "Unscan Product"
      :field-text "Barcode"
      :initial-value ""
      :save-text "Capture"
      :save-key :transfers/item-unscan
      :input-key :manual-barcode
      :input-type :barcode}}))

(defmethod grid/action :transfers/modal-box-list [app-atom _ _]
  (grid/open-modal app-atom :transfers/modal-box-list
    {:title "Choose or Scan a box"
     :heading "to print a PB sticker"
     :list (get-in @app-atom [:transfers :boxes])}))

(defn menu-modal
  [{:keys [printer?]} app-atom]
  (grid/menu-modal app-atom
    {:items
     (concat
       (cond
         printer?
         [{:label "Manual Barcode"
           :action :transfers/menu-printer-barcode}]

         :else
         [{:label "Add a Box"
           :action :transfers/modal-box-list}

          {:label "Manual Barcode"
           :action :transfers/menu-item-barcode}

          {:label "Unscan Product"
           :action :transfers/menu-unscan
           :style
           {:full true :large true :negative true
            :icon-left :delete :text-default true :icon-class :3-2}}])

       [{:label "Cancel"
         :action :transfers/menu-cancel
         :style
         {:full true :large true :text-link true :on-dark true}}])}))

(defmethod flow/barcode-dispatch-screen :transfers/item-list [_ app-atom scan]
  (grid/dispatch-action app-atom :transfers/item-scan {:scan scan}))

(defmethod grid/action :transfers/item-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [session-id sync-uuid packbox]} (get-in @app-atom [:transfers])]
    (comms/send :transfers/item-scan
      {:scan scan
       :qty 1
       :sync-uuid sync-uuid
       :packbox-id (:id packbox)
       :session-id session-id})))

(defmethod comms/receive :transfers/item-scan [app-atom {:keys [items all-items packboxes packbox sync-uuid]}]
  (toaster/close-subtle-progress app-atom)
  (cond
    (nil? items)
    (swap! app-atom assoc-in [:transfers :sync-uuid] sync-uuid)

    items
    (swap! app-atom update :transfers assoc
      :packbox packbox
      :items items
      :all-items all-items
      :sync-uuid sync-uuid
      :packbox packbox
      :packboxes packboxes)))

(rum/defc missing-item-slat < rum/reactive
  [{:keys [qty brand title scanned]}]
  (let [qty (- qty scanned)]
    [:article.slat.product-slat
     [:div.product-slat__qty [:span qty]]
     [:div.product-slat__info
      [:header.product-slat__header
       [:div.product-slat__title-wrapper
        [:h1
         {:class (u/bem :product-slat__title [:small])}
         [:b brand]
         (str " " title)]]]]]))

(rum/defc ship < rum/reactive [app-atom]
  (let [items (cmn/curact app-atom [:transfers :all-items])
        itemqty (cmn/curact app-atom [:transfers :order :itemqty])
        packeditemqty (reduce + 0 (map :scanned items))
        missingitems (filter #(not= (:qty %) (:scanned % 0)) items)]
    (w/wrapper app-atom "Transfer Stock" {:steps steps :step :ship}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str "Confirm " (when (not= itemqty packeditemqty) "Part ") "Fulfillment")]
        [:ul
         {:class (u/bem :order-calc [:fulfillment])}
         [:li.order-calc__item
          [:span.order-calc__item-icon-wrapper
           [:i {:class (u/bem :icon [:truck :block])}]]
          [:span.order-calc__item-name "Items needed:"]
          [:span.order-calc__item-value [:b itemqty]]]
         [:li.order-calc__item
          [:span.order-calc__item-icon-wrapper
           [:i {:class (u/bem :icon [:3-3 :success :block])}]]
          [:span.order-calc__item-name "Items packed:"]
          [:span.order-calc__item-value [:b.u-text-status-success packeditemqty]]]
         [:li.order-calc__item
          [:span.order-calc__item-icon-wrapper
           [:i {:class (u/bem :icon [:3-3 :error :block])}]]
          [:span.order-calc__item-name "Items not packed:"]
          [:span.order-calc__item-value
           [:b.u-text-status-negative (- itemqty packeditemqty)]]]]]
       (when (not= itemqty packeditemqty)
         [:div
          {:class (u/bem :slats [:items-missing])}
          [:h3.slat.heading-slat
           [:span.heading-slat__icon-wrapper
            [:i {:class (u/bem :icon [:error :block])}]]
           [:span.heading-slat__text "Not Packed:"]]
          (map missing-item-slat missingitems)])
       [[:div.u-margin-bottom-24
         {:class (u/bem :section [:medium])}
         (feedback/action-feedback :truck "Checked" " the transfer item list?" (rum/cursor-in app-atom [:transfers :details-confirmed]) {})]]]

      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Ship"
         :right-no-icon true
         :right-fn
         (when (cmn/curact app-atom [:transfers :details-confirmed])
           #(grid/dispatch-action app-atom :transfers/ship {}))}))))

(defmethod flow/render-screen :transfers/ship [app-atom _]
  (swap! app-atom  assoc-in [:transfers :details-confirmed] false)
  (ship app-atom))

(defmethod comms/receive :transfers/box-scan [app-atom {:keys [packboxes]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :transfers assoc
    :packbox nil
    :packboxes packboxes)
  (grid/close-modal app-atom))

(defmethod grid/action :transfers/box-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [printer session-id packbox]} (get @app-atom :transfers)]
    (comms/send :transfers/box-scan
      {:scan scan
       :selected-packbox-id (:id packbox)
       :session-id session-id
       :printer-barcode printer})))

(rum/defc packbox-slat < rum/reactive [{:keys [code barcode item-count]} on-click]
  [:a.action-button-slat.packing-box-slat
   {:class (u/bem :slat [:warning])
    :on-click on-click}
   [:div.action-button-slat__icon-wrapper
    [:i {:class (u/bem :icon [:block :package])}]]
   [:div.action-button-slat__title
    [:b (str "Packbox " barcode " - " code)]
    [:span.action-button-slat__subtext
     (str (inflections/pluralize item-count "Item") " Packed")]]
   [:div.action-button-slat__icon-wrapper
    [:i {:class (u/bem :icon [:block :dots-menu])}]]])

(rum/defc item-slat < rum/reactive
  [{:keys [barcode qty brand product scanned]}]
  (let [scanned (or scanned 0)]
    [:article.slat.product-slat.transfer-product-slat
     {:class
      (u/bem :slat
        [(cond
           (= scanned qty) :success
           (pos? scanned) :error)])}
     [:div.product-slat__qty.transfer-product-slat__qty
      [:div.transfer-product-slat__count
       [(if (zero? scanned)
          :b.u-text-status-negative
          :b) scanned]
       [:span.u-pipe "of"]
       [:span qty]]]
     [:div.product-slat__info
      [:header.product-slat__header
       [:div.product-slat__title-wrapper
        [:h1.product-slat__title
         [:span.product-slat__brand brand]
         product]]]
      [:ul.product-slat__details
       [:li.product-slat__barcode
        [:b.u-text-spaced-1 barcode]]]]]))

(defmethod comms/receive :transfers/packbox-remove [app-atom {:keys [packbox packboxes]}]
  (toaster/close-toast app-atom)
  (swap! app-atom update :transfers assoc
    :packbox packbox
    :packboxes packboxes))

(defmethod grid/action :transfers/packbox-remove [app-atom _ _]
  (toaster/open-toast app-atom :processing "Loading orders" {})
  (let [{:keys [packbox session-id modal-packbox]} (get-in @app-atom [:transfers])]
    (comms/send :transfers/packbox-remove
      {:packbox-id (:id packbox)
       :session-id session-id
       :remove-id (:id modal-packbox)})))

(defmethod grid/action :transfers/menu-packbox-remove [app-atom _ _]
  (grid/confirm-modal app-atom
    {:title "Remove Packbox"
     :text [:p {:class (u/bem :paragraph [:flush])}
            "Are you sure you want to remove this packbox?"]
     :confirm-key :transfers/packbox-remove
     :confirm-text "Yes" :icon-left :delete :icon-class :3-2 :negative true}))

(defmethod grid/action :transfers/packbox-reprint [app-atom config _]
  (let [{:keys [modal-packbox printer]} (get-in @app-atom [:transfers])]
    (comms/send :transfers/packbox-reprint
      {:packbox-id (:id modal-packbox)
       :printer-barcode printer})))

(defmethod grid/action :transfers/packbox-modal [app-atom {:keys [packbox]}]
  (swap! app-atom assoc-in [:transfers :modal-packbox] packbox)
  (grid/menu-modal app-atom
    {:items
     [{:label "Reprint Label"
       :action :transfers/packbox-reprint}

      {:label "Remove Packbox"
       :action :transfers/menu-packbox-remove
       :style
       {:full true :large true :negative true
        :icon-left :warning :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :transfers/packbox-menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))


(defmethod flow/barcode-dispatch-modal :transfers/modal-box-list [_ app-atom scan]
  (grid/dispatch-action app-atom :transfers/box-scan {:scan scan}))

(rum/defc box-slat < rum/reactive [box {:keys [on-click]}]
  [:article.slat-wrapper
   [:div.slat.packing-box-list-slat
    {:on-click on-click}
    [:h3.packing-box-list-title
     (:name box)]]])

(rum/defc box-list-body < rum/reactive [app-atom]
  (let [{:keys [list title heading]} (cmn/curact (grid/modal-cursor app-atom) :config)]
    [[:div.section
      [:div.u-margin-top-24
       [:h2.u-text-center
        {:class (u/bem :heading [:standard])}
        title
        [:span.heading__subtext
         heading]]]]
     [[:div.slats
       (map
         (fn [i]
           (rum/with-key
             (box-slat i
               {:on-click #(grid/dispatch-action app-atom :transfers/box-scan {:scan (:barcode i)})})
             (:id i)))
         list)]]]))

(defmethod grid/modal-config :transfers/modal-box-list [_ _ _]
  {:body box-list-body
   :footer grid/list-modal-footer
   :modal-type :details
   :content-type :fill})

(rum/defc item-list < rum/reactive [app-atom]
  (let [{:keys [items order boxes packbox packboxes]} (cmn/curact app-atom :transfers)
        packeditemqty (reduce + 0 (map :scanned items))]
    (w/wrapper app-atom "Transfer Stock" {:steps steps :step :item-list :modal-fn (partial menu-modal {:items? true})}
      [[:div
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str "YCT" (:id order))
         [:span.u-hidden-from-view " - "]
         [:span.heading__subtext "Requested " (str (:dateadded order))]]]
       (let [overscans (filter #(> (:qtyscanned %) (:qty %)) items)]
         [:div.slats
          [:a.action-button-slat
           {:class (u/bem :slat nil)
            :on-click
            #(grid/open-modal app-atom :transfers/modal-box-list
               {:title "Choose or Scan a box"
                :heading "to print a PB sticker"
                :list boxes})}
           [:div.action-button-slat__icon-wrapper
            [:i {:class (u/bem :icon [:block :package])}]]
           [:div.action-button-slat__title.u-text-underline
            (if (empty? packboxes)
              [:b "Add a Box"]
              [:b "Add Another Box"])]
           [:div.action-button-slat__icon-wrapper
            [:i {:class (u/bem :icon [:block :plus])}]]]

          (if packbox
            [:a.action-button-slat.packing-box-slat
             {:class (u/bem :slat [(if (empty? overscans) :success :error)])
              :on-click #(grid/dispatch-action app-atom :transfers/packbox-modal {:packbox packbox})}
             [:div.action-button-slat__icon-wrapper
              [:i {:class (u/bem :icon [:block :package])}]]
             [:div.action-button-slat__title
              [:b (str "Packbox " (:barcode packbox) " - " (:code packbox))]
              [:span.action-button-slat__subtext
               (str (inflections/pluralize (:item-count packbox) "Item") " Packed")]]
             [:div.action-button-slat__icon-wrapper
              [:i {:class (u/bem :icon [:block :dots-menu])}]]]
            [:a.action-button-slat
             {:class (u/bem :slat nil)
              :on-click nil}
             [:div.action-button-slat__icon-wrapper
              [:i {:class (u/bem :icon [:block :barcode-scan])}]]
             [:div
              [:div.action-button-slat__title
               [:b "Scan a Packbox"]]]])
          (map
            (fn [i]
              (rum/with-key
                (item-slat i)
                (:barcode i)))
            items)])

       (when-not (empty? packboxes)
         [:div.slats
          [:a.action-button-slat
           {:class (u/bem :slat nil)
            :on-click nil}
           [:div.action-button-slat__icon-wrapper
            [:i {:class (u/bem :icon [:block :package])}]]
           [:div
            [:div.action-button-slat__title
             [:b "Other Packboxes - Scan to Select"]]]]
          (map
            (fn [p]
              (rum/with-key
                (packbox-slat p
                  #(grid/dispatch-action app-atom :transfers/packbox-modal {:packbox p}))
                (:id p)))
            packboxes)])]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (when (pos? packeditemqty)
           #(t/transition-next app-atom :transfers/ship))}))))

(defmethod flow/render-screen :transfers/item-list [app-atom _]
  (item-list app-atom))

(defmethod comms/receive :transfers/item-list [app-atom {:keys [boxes items session-id sync-uuid]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :transfers assoc
    :session-id session-id
    :items items
    :sync-uuid sync-uuid
    :boxes boxes)
  (t/transition-next app-atom :transfers/item-list))

(defmethod grid/action :transfers/printer-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (swap! app-atom assoc-in [:transfers :printer] scan)
  (let [{:keys [order]} (get @app-atom :transfers)]
    (comms/send :transfers/item-list
      {:ibt-id (:id order)})))

(defmethod flow/barcode-dispatch-screen :transfers/printer-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :transfers/printer-scan {:scan scan}))

(rum/defc printer-scan < rum/reactive [app-atom]
  (w/wrapper app-atom "Transfer Stock" {:steps steps :step :printer-scan :modal-fn (partial menu-modal {:printer? true})}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Printer"
       [:span.heading__subtext "for printing PB stickers"]]
      grid/barcode-icon]]
    []

    (grid/pos-call-to-action
      {:left-fn #(grid/dispatch-action app-atom :transfers/order-list {})
       :right-text "Scan Printer"
       :right-plain true})))

(defmethod flow/render-screen :transfers/printer-scan [app-atom _]
  (printer-scan app-atom))

(defmethod grid/action :transfers/order-select [app-atom {:keys [order]}]
  (swap! app-atom update :transfers assoc
    :order order
    :uuid (u/rand-uuid))
  (t/transition-next app-atom :transfers/printer-scan))

(rum/defc order-slat < rum/reactive
  [{:keys [packername packeddate status barcode notes dateadded itemqty]} {:keys [on-click]}]
  [:article.slat.transfer-order-slat
   {:on-click (when on-click on-click)}
   [:header.transfer-order-slat__header
    [:div.transfer-order-slat__title-wrapper
     [:h1.transfer-order-slat__title
      [:span.transfer-order-slat__order-no barcode]
      [:span.transfer-order-slat__date
       (str "Requested: " (str dateadded))]
      (when packername
        [:span.transfer-order-slat__user
         (str "Packed by " packername " on " packeddate)])]]]
   [:ul.transfer-order-slat__details
    [:li.transfer-order-slat__notes notes]]
   [:ul.transfer-order-slat__details
    [:li.transfer-order-slat__item-count (inflections/pluralize itemqty "Item")]
    [:li.transfer-order-slat__status
     [(case status
        "Ready"
        :span.u-text-status-success
        :span.u-text-status-warning) [:b status]]]]])

(rum/defc order-list < rum/reactive [app-atom]
  (let [orders (cmn/curact app-atom [:transfers :orders])
        orders? (not (empty? orders))]
    (w/wrapper app-atom "Transfer Stock" {:steps steps :step :order-list}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (if orders?
           "Transfer Orders"
           "No Transfer Orders")]]
       (map
         (fn [o]
           (rum/with-key
             (order-slat
               o
               {:on-click #(grid/dispatch-action app-atom :transfers/order-select {:order o})})
             (:id o)))
         orders)]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Select Order"
         :right-plain true}))))

(defmethod flow/render-screen :transfers/order-list [app-atom _]
  (order-list app-atom))

(defmethod comms/receive :transfers/order-list [app-atom {:keys [orders sync-uuid]}]
  (toaster/close-toast app-atom)
  (swap! app-atom assoc :transfers
    {:orders orders
     :sync-uuid sync-uuid})
  (t/transition-next app-atom :transfers/order-list))

(defmethod grid/action :transfers/order-list [app-atom]
  (toaster/open-toast app-atom :processing "Loading orders" {})
  (comms/send :transfers/order-list {}))

(rum/defc transfers-screen-start < rum/reactive [app-atom]
  (w/wrapper app-atom "Transfer Stock" {:steps steps :step :select-option}
    [[:div.u-margin-top-24
      [:div {:class (u/bem :section [:medium])}
       [:nav
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "What would you like to do?"]
        [:a.card.tile.u-angled-background.u-bg-teal-blue.u-min-height-160
         {:style {:height "auto"}
          :on-click
          #(grid/dispatch-action app-atom :transfers/order-list {})}
         [:span.tile__content
          [:span.tile__icon-wrapper
           [:i.tile__icon
            {:class (u/bem :icon [:2-2 :menu :large :block])}]]
          [:span.tile__text "Orders List"]]]

        (when
          (or
            (cmn/has-permission? app-atom "SiteAdmin:Store:Manager")
            (cmn/has-permission? app-atom "SiteAdmin:Store:Assistant Manager")
            (cmn/has-permission? app-atom "SiteAdmin:Teams:Development"))
          [:a.card.or-card.tile.u-angled-background.u-bg-deep-purple.u-min-height-160
           {:style {:height "auto"}
            :on-click
            #(grid/dispatch-action app-atom :manualtransfers/warehouse-list {})}
           [:span.tile__content
            [:span.tile__icon-wrapper
             [:i.tile__icon
              {:class (u/bem :icon [:2-2 :package :large :block])}]]
            [:span.tile__text "Custom Box"]]])]]]]
    []
    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom :main-menu)
       :right-plain true})))

(defmethod flow/render-screen :transfers/select-option [app-atom _]
  (transfers-screen-start app-atom))